import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MarinaTermUse } from "../models/marina-term-use";
import { TermUseType } from "../models/enums/term-use-type";

@Injectable()
export class MarinaTermUseService {

    constructor(
        private http: HttpClient
    ) { }

    save(termUse): Observable<MarinaTermUse> {
        return this.http.post(environment.apiHost + '/secure/term-use', termUse)
            .pipe(map((response: any) => response.data.termUse as MarinaTermUse));
    }

    get(): Observable<MarinaTermUse> {
        return this.http.get(environment.apiHost + '/secure/term-use')
            .pipe(map((response: any) => response.data.termUse as MarinaTermUse));
    }

    getStatus(type: TermUseType): Observable<{ currentVersion: number, documentUrl: string, content: string, accepted: boolean, requireAcceptance: boolean }> {
        return this.http.get(environment.apiHost + '/secure/term-use/status', { params: { type } })
            .pipe(map((response: any) => response.data.status));
    }

}
